@if (authService.isLoading()) {
<div class="root-loading-container">
  <mat-spinner diameter="36"></mat-spinner>
  <p class="loading-text">{{ 'STARTUP.LOADING' | translate}}</p>
</div>
} @else {
<router-outlet></router-outlet>
}
